import styled from 'styled-components';

export const SWrapper = styled.div`
  width: 100%;

  padding-bottom: 15px;
  display: flex;
  align-items: center;
`;

export const SContent = styled.div`
  width: 83%;
`;

interface ITitleProps {
  active?: boolean;
}

export const STitle = styled.div<ITitleProps>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.quaternaryText};

  ${({ active, theme }) =>
    active &&
    `
        color: ${theme.colors.tertiaryText};`}
`;

interface IValueProps {
  active?: boolean;
}

export const SValue = styled.div<IValueProps>`
  width: 100%;

  font-size: 15px;
  color: ${({ theme }) => theme.colors.secondaryText};

  ${({ active, theme }) =>
    active &&
    `
      color: ${theme.colors.primaryText};`}
`;

export const SIcon = styled.i`
  margin-right: 15px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.icon};
`;
